import { gsap, ScrollTrigger, screenSm } from './1.1_animations-defaults.js';
import Choices from 'choices.js';
import 'choices.js/public/assets/styles/choices.min.css'; // Import the CSS for styling

const CHOICES_INPUT_CLASS = 'choices__input';
const MAIN_INPUT_CLASS = 'choices__list--single';

class DropDown {
    constructor() {
        this._choicesInstances = [];
        this._run();
        document.addEventListener('wpgbrender', () => {
            this._run();
        });

        document.addEventListener('resize', this._run());
    }
    _run = () => {
        this._dropdowns = document.querySelectorAll('select');
        if (this._dropdowns) {
            this._destroyDropdowns();
            this._activateDropdowns();
        }
    };
    _destroyDropdowns = () => {
        this._choicesInstances.forEach((choice) => choice.destroy());
        this._choicesInstances = [];
    };
    _activateDropdowns = () => {
        this._dropdowns.forEach((dropdown) => {
            if (!dropdown.classList.contains(CHOICES_INPUT_CLASS)) {
                const select = new Choices(dropdown, {
                    silent: false,
                    searchEnabled: false,
                    itemSelectText: '',
                    removeItemButton: false,
                    shouldSort: false,
                    // placeholder: true,
                    // placeholderValue: dropdown.name,
                });

                if (select.getValue().id === 1) {
                    select.setChoiceByValue(dropdown.options[0].value);
                    this._initSelect(dropdown);
                }
                this._choicesInstances.push(select);

                this._initSelect(dropdown);
                dropdown.addEventListener('choice', () => {
                    if (typeof select.getValue() === 'undefined') {
                        this._initSelect(dropdown);
                    }
                });

                if (innerWidth >= screenSm) {
                    dropdown.parentElement.parentElement.addEventListener('mouseenter', () => {
                        this._pointerEnter(select);
                    });
                    dropdown.parentElement.parentElement.addEventListener('mouseleave', () => {
                        this._pointerLeave(select);
                    });
                    dropdown.parentElement.addEventListener('click', (e) => {
                        e.stopPropagation();
                    });
                }
            }
        });
    };
    _initSelect = (dropdown) => {
        if (!dropdown.value) {
            setTimeout(() => {
                let textNode = dropdown.parentElement.querySelector(`.${MAIN_INPUT_CLASS} > div`);

                if (textNode) {
                    textNode.innerText = dropdown.name.split('_')[0];
                }
            }, 0);
        }
    };
    _pointerEnter = (select) => {
        select.showDropdown();
    };
    _pointerLeave = (select) => {
        select.hideDropdown();
    };
}
const dropDown = new DropDown();
